<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="请输入活动名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="活动状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in ACTIVITY_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        style="margin-right:24px"
        startPlaceholder="开始时间"
        endPlaceholder="结束时间"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="name" label="活动名称"></el-table-column>
      <el-table-column label="开始时间" align="center" prop="startTime">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.startTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" align="center" prop="endTime">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.endTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag style="color: #FFF;" :color="getValue(BRAND_STATUS_CSS, scope.row.status)">{{
            getValue(ACTIVITY_STATUS, scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="活动总限购"
        width="160"
        align="center"
        prop="totalLimit"
      ></el-table-column>

      <el-table-column align="center" prop="singleLimit" label="单次限购" width="120">
      </el-table-column>
      <el-table-column align="center" prop="sort" label="排序"> </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新增/编辑活动弹框 -->
    <ActivityForm
      :visible.sync="dialogFormVisible"
      :dialog-type="dialogType"
      :edit-data="editRow"
      :btn-loading="btnLoading"
      @confirm="saveActivityData"
    />
  </div>
</template>

<script>
import { getActivityList, editActivity, deleteActivity } from "@/api/seckill";
import DataPicker from "@/views/components/dataPicker.vue";
import ActivityForm from "./activityForm.vue";
import { formatApiDate } from "@/utils/utils";
import { BRAND_STATUS_CSS } from "@/utils/enumUtileCss";
import { ACTIVITY_STATUS, getValue } from "@/utils/enumUtile";

export default {
  computed: {
    ACTIVITY_STATUS() {
      return ACTIVITY_STATUS;
    },
    formatApiDate() {
      return formatApiDate;
    },
    BRAND_STATUS_CSS() {
      return BRAND_STATUS_CSS;
    }
  },
  components: { DataPicker, ActivityForm },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        name: null,
        status: null,
        startTime: null,
        endTime: null
      },
      dialogFormVisible: false,
      dialogType: "",
      editRow: {},
      btnLoading: false
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        name: null,
        status: null,
        startTime: null,
        endTime: null
      };
      this.getList();
    },

    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.startTime = value[0];
        this.listQuery.endTime = value[1];
      }
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDelete(row) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteActivity({ id: row.id })
          .then(() => {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000
            });
            this.getList();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getActivityList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 打开新增/编辑弹框
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      this.editRow = editObj;
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 保存活动数据
     * @param params
     */
    saveActivityData(params) {
      this.btnLoading = true;
      editActivity(params)
        .then(() => {
          this.getList();
          this.dialogFormVisible = false;
          this.$notify({
            title: "成功",
            message: "保存成功",
            type: "success",
            duration: 2000
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss"></style>
